import { ProductLogo } from 'app/modules/products/components/ProductLogo';
import { track } from "../../core/App/track";
import { useFormik } from 'formik';
import { Box, Button, FormGroup, Select, VGrid, useToasts } from 'tombac';
import { CancelIcon } from 'tombac-icons';
import { object, string } from 'yup';
import { CharCounter } from "./CharCounter";
import { usePublishSupportFormMutation } from "./dashboardApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const validationSchema = object({
  product: string().required('Product is required.'),
  topic: string().required('Topic is required'),
  message: string().required('Message is required').max(2000, 'Message must be less than 2000 characters.')
});
const availableTopics = [{
  label: 'I have a product question',
  value: 'I have a product question'
}, {
  label: "I think I've found a bug",
  value: "I think I've found a bug"
}, {
  label: 'I have other question',
  value: 'I have other question'
}];
const ModalSupportForm = ({
  products,
  onRequestClose,
  onSubmitForm,
  userEmail,
  isMobile = false
}) => {
  const {
    addToast
  } = useToasts();
  const {
    mutateAsync: publishSupportForm
  } = usePublishSupportFormMutation();
  const formik = useFormik({
    initialValues: {
      product: '',
      topic: '',
      message: ''
    },
    onSubmit: values => publishSupportForm({
      values
    }).then(() => {
      userEmail && track('form_submit', {
        category: 'dashboard',
        specificProps: {
          form_type: 'mp_contact_support',
          visitor_type: 'known',
          account_type: 'move',
          staticId: Buffer.from(userEmail).toString('base64')
        }
      });
      onSubmitForm();
    }).catch(() => {
      addToast('Failed to send the form, please try again', 'danger');
    }),
    validateOnMount: true,
    validationSchema
  });
  const getFormGroupProps = name => ({
    caption: formik.touched[name] && formik.errors[name],
    danger: Boolean(formik.touched[name] && formik.errors[name])
  });
  const getInputProps = name => ({
    invalid: Boolean(formik.touched[name] && formik.errors[name]),
    name,
    ...formik.getFieldProps(name)
  });
  const renderDropdownOptions = () => {
    return products.map(product => {
      return {
        label: /*#__PURE__*/_jsxs("div", {
          className: "DashboardContactModal__SelectProductInfo",
          children: [/*#__PURE__*/_jsx(ProductLogo, {
            productId: product.id
          }), product.name]
        }),
        value: product.id
      };
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "DashboardContactModal_FormLabel",
      children: ["Request help from TomTom support", ' ', !isMobile && /*#__PURE__*/_jsx("span", {
        className: "DashboardContactModal_closeIco",
        onClick: onRequestClose,
        children: /*#__PURE__*/_jsx(CancelIcon, {})
      })]
    }), /*#__PURE__*/_jsxs("form", {
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/_jsx(VGrid, {
        gap: 10,
        justifyContent: "stretch",
        $w: isMobile ? '100%' : '74sp',
        "data-sentry-element": "VGrid",
        "data-sentry-source-file": "ModalSupportForm.tsx",
        "data-sentry-element": "VGrid",
        children: /*#__PURE__*/_jsx(FormGroup, {
          htmlFor: "product-input",
          label: "Product",
          className: "DashboardContactModal__label--required",
          ...getFormGroupProps('product'),
          "data-sentry-element": "FormGroup",
          "data-sentry-source-file": "ModalSupportForm.tsx",
          "data-sentry-element": "FormGroup",
          children: /*#__PURE__*/_jsx(Select, {
            placeholder: "Select the product",
            options: renderDropdownOptions(),
            id: "product-input",
            ...getInputProps('product'),
            onBlur: () => formik.setFieldTouched('product'),
            onChange: product => !('length' in product) && formik.setFieldValue('product', product.value),
            value: renderDropdownOptions().find(o => o.value === formik.values.product),
            "data-sentry-element": "Select",
            "data-sentry-source-file": "ModalSupportForm.tsx",
            "data-sentry-element": "Select"
          })
        })
      }), /*#__PURE__*/_jsx(VGrid, {
        $mt: "3sp",
        gap: 10,
        justifyContent: "stretch",
        $w: isMobile ? '100%' : '74sp',
        "data-sentry-element": "VGrid",
        "data-sentry-source-file": "ModalSupportForm.tsx",
        "data-sentry-element": "VGrid",
        children: /*#__PURE__*/_jsx(FormGroup, {
          htmlFor: "topic-input",
          className: "DashboardContactModal__label--required",
          label: "Topic",
          ...getFormGroupProps('topic'),
          "data-sentry-element": "FormGroup",
          "data-sentry-source-file": "ModalSupportForm.tsx",
          "data-sentry-element": "FormGroup",
          children: /*#__PURE__*/_jsx(Select, {
            placeholder: "Select the topic",
            options: availableTopics,
            id: "topic-input",
            ...getInputProps('topic'),
            onBlur: () => formik.setFieldTouched('topic'),
            onChange: topic => !('length' in topic) && formik.setFieldValue('topic', topic.value),
            value: availableTopics.find(o => o.value === formik.values.topic),
            "data-sentry-element": "Select",
            "data-sentry-source-file": "ModalSupportForm.tsx",
            "data-sentry-element": "Select"
          })
        })
      }), /*#__PURE__*/_jsx(VGrid, {
        $mt: "3sp",
        justifyContent: "stretch",
        $w: isMobile ? '100%' : '74sp',
        "data-sentry-element": "VGrid",
        "data-sentry-source-file": "ModalSupportForm.tsx",
        "data-sentry-element": "VGrid",
        children: /*#__PURE__*/_jsx(FormGroup, {
          htmlFor: "message-input",
          className: "DashboardContactModal__label--required",
          label: "Message",
          ...getFormGroupProps('message'),
          "data-sentry-element": "FormGroup",
          "data-sentry-source-file": "ModalSupportForm.tsx",
          "data-sentry-element": "FormGroup",
          children: /*#__PURE__*/_jsxs("div", {
            className: "DashboardContactForm__textareaWrapper",
            children: [/*#__PURE__*/_jsx("textarea", {
              placeholder: "How can we help you?",
              rows: 10,
              className: "DashboardContactForm__textarea",
              id: "message-input",
              ...getInputProps('message')
            }), /*#__PURE__*/_jsx(CharCounter, {
              value: `${formik.values.message.length}/2000 `,
              "data-sentry-element": "CharCounter",
              "data-sentry-source-file": "ModalSupportForm.tsx",
              "data-sentry-element": "CharCounter"
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(Box, {
        $display: "flex",
        $mt: "3sp",
        $flexDirection: "row-reverse",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "ModalSupportForm.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Button, {
          busy: formik.isSubmitting,
          type: "submit",
          variant: "primary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ModalSupportForm.tsx",
          "data-sentry-element": "Button",
          children: "Send message"
        }), isMobile && /*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          onClick: onRequestClose,
          type: "button",
          children: "Back"
        })]
      })]
    })]
  });
};
export default ModalSupportForm;